import { motion } from "framer-motion";

const CREDS = ["Pre & postnatal specialist", "Classical apparatus method", "Former Alvin Ailey dancer", "Equinox · Third Space · Wilder Studios · Sophie Rose"];

export default function Instructor() {
  return (
    <section id="instructor" data-testid="instructor-bio-section" className="bg-[#F3EDE2] py-24 sm:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5 relative"
          >
            <div className="overflow-hidden clip-arch">
              <img src="/instructor-jessica.jpg" alt="Jessica Bacon — Pilates instructor" className="w-full h-[520px] object-cover object-[center_25%]" />
            </div>
            <div className="absolute -bottom-6 -right-2 sm:right-6 bg-[#2D4A3E] text-[#FAF7F2] rounded-2xl px-6 py-4" data-testid="instructor-badge">
              <p className="font-display italic text-xl">The journey</p>
              <p className="label text-[#C5A059] mt-1">starts at home</p>
            </div>
          </motion.div>

          <div className="lg:col-span-7">
            <p className="eyebrow label text-[#2D4A3E] mb-6">Your instructor</p>
            <h2 className="font-display text-4xl sm:text-5xl leading-[1.06] tracking-tight text-[#1C1917]">
              Meet Jessica Bacon.
            </h2>
            <div className="mt-7 space-y-5 text-[#57534E] text-lg leading-relaxed max-w-2xl">
              <p>
                Jessica trained with Alvin Ailey American Dance Theater and danced professionally as a
                ballet dancer before becoming a classical Pilates instructor. That foundation in movement
                shapes everything she teaches.
              </p>
              <p>
                She specialises in classical Pilates on the full apparatus — reformer, Cadillac, Wunda
                Chair, Ladder Barrel and Spine Corrector — and in pre- and postnatal Pilates, bringing
                private sessions directly to clients' homes across Hampstead and North London.
              </p>
              <p>
                Alongside her private work, Jessica also teaches at Equinox, Third Space, Wilder Studios
                and Sophie Rose.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-3 max-w-xl" data-testid="instructor-credentials">
              {CREDS.map((c) => (
                <div key={c} className="flex items-center gap-3 rounded-xl bg-[#FAF7F2] border border-[#1C1917]/8 px-4 py-3">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#C5A059]" />
                  <span className="label text-[#57534E] text-[0.62rem]">{c}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
